/**
 * O painel de Fotografias e facial da mesa (E205.F3, ADR-0147). Saiu da `PreAnaliseEletronicaPage`
 * quando ela passaria do teto de linhas. E205.F4: a leitura das imagens de documento se confirma na
 * linha do documento, na aba Documentos.
 */
import {
  FotografiasDoCaso,
  FotografiasDoCasoLidas,
} from '@/components/ExameEletronico/FotografiasDoCaso';
import { PainelDaAba } from '@/components/MesaUnica/AbasDaMesa';
import type { ArquivoPendenteData } from '@/lib/arquivos_pendentes';
import type { FotografiasDoCaso as LeituraDasFotografias } from '@/lib/useFotografiasDoCaso';

export interface PecasDasFotografiasProps {
  caseId: string;
  concluido: boolean;
  releitura: number;
  /** Uma entrada mudou (a leitura confirmada, a análise que terminou): rearma o processamento. */
  onEntradaMudou: () => void;
  /** A leitura das fotografias que a mesa já faz; sem ela, a seção lê a sua. */
  fotografias?: LeituraDasFotografias | undefined;
  /** E206.F2 (GUS-296 item 2): o que falta ao caso digital; a comparação espera. */
  arquivosPendentes?: readonly ArquivoPendenteData[] | undefined;
}

/** E123.F3 (GUS-128, E.24): fotos eleitas e conferência facial, o perito revisa aqui. */
export function PainelDasFotografias(props: PecasDasFotografiasProps): JSX.Element {
  const { caseId, concluido, releitura, onEntradaMudou, fotografias, arquivosPendentes } = props;
  return (
    <PainelDaAba aba="fotografias">
      {fotografias !== undefined ? (
        <FotografiasDoCasoLidas
          key={caseId}
          caseId={caseId}
          concluido={concluido}
          releitura={releitura}
          onEntradaMudou={onEntradaMudou}
          leitura={fotografias}
          semLeituras
          arquivosPendentes={arquivosPendentes}
        />
      ) : (
        <FotografiasDoCaso
          key={caseId}
          caseId={caseId}
          concluido={concluido}
          releitura={releitura}
          onEntradaMudou={onEntradaMudou}
          arquivosPendentes={arquivosPendentes}
        />
      )}
    </PainelDaAba>
  );
}
